/*
 * Copyright 2025 Intuition Robotics ltd
 */
import React from 'react';
import '../css/style.css'

type ConfirmAlertProps = {
    onConfirm: () => void;
    onCancel: () => void;
    title: string;
    text: string;
    confirmText: string;
    cancelText: string;
};

const ConfirmAlert: React.FC<ConfirmAlertProps> = ({onConfirm, onCancel, title, text, confirmText, cancelText}) => {
    return (
        <div className={'alertContainer active'}>
            <div className='alertOverlay'>
                <h2>{title}</h2>
                <p>{text}</p>
                <div className='btnContainer'>
                    <button onClick={onCancel}>{cancelText}</button>
                    <button className='confirmBtn' onClick={onConfirm}>{confirmText}</button>
                </div>
            </div>
        </div>
    )
};

export default ConfirmAlert